import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { SiteAssetType } from '~/app/sites/[id]/map/hooks/useSiteData'

type SiteAssetTypeOptions = {
  format?: 'singular' | 'plural'
}

export default function useSiteAssetTypeFormatter() {
  const t = useTranslations('data.siteAssetType')
  return useCallback(
    (assetType: SiteAssetType, options?: SiteAssetTypeOptions) => {
      const format = options?.format ?? 'singular'
      return t(`${format}_${assetType}`)
    },
    [t]
  )
}
